import { KeyringHook } from "./Logics/HookCreation/hook_creation_predefined.js";
export default KeyringHook;
